import { Component, OnInit } from '@angular/core';

import { ContactMessage } from '../models/ContactMessage';

import { ContactService } from './contactService/contact.service';

import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

// import { ContactService } from '../contact.service'; // مسیر سرویس را تنظیم کنید
// فرض می‌کنیم این اینترفیس در فایل models/contact-message.model.ts تعریف شده است




@Component({
  selector: 'app-contact',
  templateUrl: './admin-messages.component.html',
  styleUrls: ['./admin-messages.component.css'] // یا contact.component.scss اگر از SCSS استفاده می‌کنید
})
export class AdminMessagesComponent implements OnInit {
  messages: ContactMessage[] = [];
  isLoading = false;
  errorMessage: string | null = null;

  baseUrl = environment.apiBaseUrl;

  constructor(private contactService: ContactService, private http: HttpClient) { }

  ngOnInit(): void {
    this.loadMessages();
  }

  loadMessages(): void {
    this.isLoading = true;
    this.errorMessage = null;
    this.contactService.getAdminMessages().subscribe({
      next: (data) => {
        this.messages = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading messages:', err);
        this.errorMessage = 'خطا در بارگیری پیام‌ها.';
        this.isLoading = false;
      }
    });
  }



   // حذف پیام
  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این پیام را حذف کنید؟")) {
        this.http.post(`${this.baseUrl}/contact/delete/${Id}`, null).subscribe(() => {

        this.loadMessages(); // بعد از حذف، لیست پیام ها را مجدد بگیر
      });
    }
  }



}
